import { Action } from 'redux';

export const SHOW_IMPORT_ORDERS_MODAL = 'import-orders/SHOW_IMPORT_ORDERS_MODAL';
export const HIDE_IMPORT_ORDERS_MODAL = 'import-orders/HIDE_IMPORT_ORDERS_MODAL';
export const SHOW_IMPORT_ORDERS_PROCESS_MODAL = 'import-orders/SHOW_IMPORT_ORDERS_PROCESS_MODAL';
export const HIDE_IMPORT_ORDERS_PROCESS_MODAL = 'import-orders/HIDE_IMPORT_ORDERS_PROCESS_MODAL';

export const SHOW_IMPORT_ORDERS_EXPORT_MODAL = 'import-orders/SHOW_IMPORT_ORDERS_EXPORT_MODAL';
export const HIDE_IMPORT_ORDERS_EXPORT_MODAL = 'import-orders/HIDE_IMPORT_ORDERS_EXPORT_MODAL';

export const GET_FAILED_RECORDS_DATA_IMPORT = 'data-import/GET_FAILED_DATA_IMPORT';
export const SET_FAILED_RECORDS_DATA_IMPORT = 'data-import/SET_FAILED_RECORDS_DATA_IMPORT';

export const SET_MAPPED_FILE_DATA = 'import-orders/SET_MAPPED_FILE_DATA';
export const setMappedFileData = (data: ImportOrderMappingPayload | undefined) => ({
  type: SET_MAPPED_FILE_DATA,
  payload: data,
});

export const CREATE_IMPORT_ORDER_MAPPING = 'import-orders/CREATE_IMPORT_ORDER_MAPPING';
export const createImportOrderMapping = (data: ImportOrderMappingPayload) => ({
  type: CREATE_IMPORT_ORDER_MAPPING,
  payload: data,
});

export const GET_MAPPED_LIST = 'import-orders/GET_MAPPED_LIST';
export const getMappedList = (data?: string) => ({
  type: GET_MAPPED_LIST,
  payload: data,
});

export const SET_MAPPED_LIST = 'import-orders/SET_MAPPED_LIST';
export const setMappedList = (data: ReadonlyArray<ImportOrderMappingPayload>) => ({
  type: SET_MAPPED_LIST,
  payload: data,
});

export const showImportOrdersModal = () => {
  return {
    type: SHOW_IMPORT_ORDERS_MODAL,
  };
};
export const hideImportOrdersModal = () => {
  return {
    type: HIDE_IMPORT_ORDERS_MODAL,
  };
};

export const showImportOrdersProcessModal = () => {
  return {
    type: SHOW_IMPORT_ORDERS_PROCESS_MODAL,
  };
};
export const hideImportOrdersProcessModal = () => {
  return {
    type: HIDE_IMPORT_ORDERS_PROCESS_MODAL,
  };
};

export const showImportOrdersExportModal = () => {
  return {
    type: SHOW_IMPORT_ORDERS_EXPORT_MODAL,
  };
};
export const hideImportOrdersExportModal = () => {
  return {
    type: HIDE_IMPORT_ORDERS_EXPORT_MODAL,
  };
};

export const UPLOAD_IMPORT_ORDER_FILE = 'import-orders/UPLOAD_IMPORT_ORDER_FILE';
export const uploadImportOrderFile = (data: UploadImportOrderFile) => ({
  type: UPLOAD_IMPORT_ORDER_FILE,
  payload: data,
});

export const SET_UPLOAD_IMPORT_ORDER_FILE = 'import-orders/SET_UPLOAD_IMPORT_ORDER_FILE';
export const setUploadImportOrderFiles = (data: any) => ({
  type: SET_UPLOAD_IMPORT_ORDER_FILE,
  payload: data,
});

export const SET_PROGRESS_BAR_RESPONSE = 'import-orders/SET_PROGRESS_BAR_RESPONSE';
export const setProgressBarResponse = (data: SuccessProcessResponse | undefined) => ({
  type: SET_PROGRESS_BAR_RESPONSE,
  payload: data,
});

export const GET_IMPORT_ORDERS = 'import-orders/GET_IMPORT_ORDERS';
export const getImportOrders = () => ({
  type: GET_IMPORT_ORDERS,
});

export const SET_IMPORT_ORDERS = 'import-orders/SET_IMPORT_ORDERS';
export const setImportOrders = (data: ReadonlyArray<ImportOrderTableData>) => ({
  type: SET_IMPORT_ORDERS,
  payload: data,
});

export const getFailedDataImport = (data: any) => {
  return {
    type: GET_FAILED_RECORDS_DATA_IMPORT,
    payload: data,
  };
};
export const setFailedDataImport = (data: any) => {
  return {
    type: SET_FAILED_RECORDS_DATA_IMPORT,
    payload: data,
  };
};

export const DOWNLOAD_IMPORT_FILE = 'import-orders/DOWNLOAD_IMPORT_FILE';
export const downloadImportFile = (id: string | number) => ({
  type: DOWNLOAD_IMPORT_FILE,
  payload: id,
});

export interface ShowImportOrdersModalAction extends Action<typeof SHOW_IMPORT_ORDERS_MODAL> {}
export interface HideImportOrdersModalAction extends Action<typeof HIDE_IMPORT_ORDERS_MODAL> {}

export interface ShowImportOrdersProcessModalAction extends Action<typeof SHOW_IMPORT_ORDERS_PROCESS_MODAL> {}
export interface HideImportOrdersProcessModalAction extends Action<typeof HIDE_IMPORT_ORDERS_PROCESS_MODAL> {}

export interface ShowImportOrdersExportModalAction extends Action<typeof SHOW_IMPORT_ORDERS_EXPORT_MODAL> {}
export interface HideImportOrdersExportModalAction extends Action<typeof HIDE_IMPORT_ORDERS_EXPORT_MODAL> {}

export interface SetMappedFileDataAction extends Action<typeof SET_MAPPED_FILE_DATA> {
  readonly payload: ImportOrderMappingPayload;
}
export interface SetMappedListAction extends Action<typeof SET_MAPPED_LIST> {
  readonly payload: ReadonlyArray<ImportOrderMappingPayload>;
}

export interface SetProgressBarResponseAction extends Action<typeof SET_PROGRESS_BAR_RESPONSE> {
  readonly payload: SuccessProcessResponse | undefined;
}
export interface SetImportOrderAction extends Action<typeof SET_IMPORT_ORDERS> {
  readonly payload: ReadonlyArray<ImportOrderTableData>;
}

export interface ImportorderID extends Action<typeof UPLOAD_IMPORT_ORDER_FILE> {
  readonly payload: UploadImportOrderFile;
}
export interface setImportorderID extends Action<typeof SET_UPLOAD_IMPORT_ORDER_FILE> {
  readonly payload: UploadImportOrderFile;
}

export interface SetDataFailedRecordsImportAction extends Action<typeof SET_FAILED_RECORDS_DATA_IMPORT> {
  payload: any;
}

export type ImportOrdersAction =
  | ShowImportOrdersModalAction
  | HideImportOrdersModalAction
  | ShowImportOrdersProcessModalAction
  | HideImportOrdersProcessModalAction
  | ShowImportOrdersExportModalAction
  | HideImportOrdersExportModalAction
  | SetMappedFileDataAction
  | SetMappedListAction
  | SetProgressBarResponseAction
  | SetImportOrderAction
  | SetDataFailedRecordsImportAction
  | ImportorderID
  | setImportorderID;
